import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=2cf3eb0c&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=2cf3eb0c&prod&scoped=true&lang=css"
import style1 from "./userDetails.vue?vue&type=style&index=1&id=2cf3eb0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3eb0c",
  null
  
)

export default component.exports